// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UaE89M7HdSmNWV {
  padding: var(--ds-space-0, 0);
  border: none;
  background-color: transparent;
  box-shadow: none;
  color: var(--ds-icon, #44546f);
  text-decoration: none;
}
.UaE89M7HdSmNWV:active,
.UaE89M7HdSmNWV:hover {
  border: none;
  outline: 0;
  background-color: transparent;
  box-shadow: none;
  color: var(--ds-icon-accent-gray, #758195);
  cursor: pointer;
}
`, ""]);
// Exports
export var closeButton = `UaE89M7HdSmNWV`;
export default ___CSS_LOADER_EXPORT___;
